/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IBodegasPersonas from './entidades/bodegasPersonas';
import IBodegasPersonasCompuesta from './entidades/bodegasPersonasCompuesta';
import IBodegasPersonasFiltro from './entidades/bodegasPersonasFiltro';

export default class ModeloBodegasPersonas {
    public consultarBodegasPersonas() {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocio.get('BodegasPersonas/ConsultarListaBodegasPersonas')
        );
    }

    public consultarBodegasPersonasCompuesta(bodegasPersonas: IBodegasPersonasFiltro) {
        return manejadorRest<IRespuesta<IBodegasPersonasCompuesta>>(
            () => negocio.post('BodegaUsuario/ConsultarBodegaPersonaCompuesta', bodegasPersonas),
            true
        );
    }  

    public crearBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocio.post('BodegaUsuario/GuardarBodegaPersona', bodegasPersonas)
        );
    }

    public editarBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocio.put('BodegaUsuario/EditarBodegaPersona', bodegasPersonas)
        );
    }

    public eliminarBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocio.delete('BodegaUsuario/EliminarBodegaPersona', bodegasPersonas)
        );
    }
}
